import { translationTaskConstant } from 'actionTypes/translationTask.constant';
import { LanguageActionTypes } from 'types/actions/translation';
import { LanguageState } from 'types/reducers/translation';

const initialState: LanguageState = {
  data: [],
};

const languageReducer = (state = initialState, action: LanguageActionTypes) => {
  switch (action.type) {
    case translationTaskConstant.FETCH_ALL_LANGUAGE_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
